import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { useUnifiedRegistry } from "../unified-registry-context";

export const useNavigationReset = () => {
  const registry = useUnifiedRegistry();
  const location = useLocation();
  useEffect(() => {
    if (registry.modal) {
      return;
    }
    registry.resetOnNavigation();
  }, [location.pathname, registry]);
};
